import { render, staticRenderFns } from "./launch-weapp.vue?vue&type=template&id=45df94a0&scoped=true"
import script from "./launch-weapp.vue?vue&type=script&lang=ts"
export * from "./launch-weapp.vue?vue&type=script&lang=ts"
import style0 from "./launch-weapp.vue?vue&type=style&index=0&id=45df94a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df94a0",
  null
  
)

export default component.exports